module.exports = __webpack_public_path__ + "img/eye-cross.56e6c8eb.svg";